import { action, makeObservable, observable } from 'mobx';
import { ALL_GAMES_COLUMN_ID } from '../core/constants/liveBetsContants';
import { DefaultQueryParams } from '../core/constants/defaultQueryParams';
import { parseQuery } from '../core/helpers/parseQuery';
import { isMobile } from '../core/helpers/isMobile';

class LiveUpdateStore {
  selectedColumn = ALL_GAMES_COLUMN_ID;

  allGamesLiveSpins = [];

  liveSpinsByGame = [];

  highRollers = [];

  betCountView = isMobile() ? 10 : 20;

  constructor() {
    makeObservable(this, {
      highRollers: observable.deep,
      selectedColumn: observable.deep,
      liveSpinsByGame: observable.deep,
      allGamesLiveSpins: observable.deep,
      setHighRollers: action.bound,
      setSelectedColumn: action.bound,
      updateHighRollers: action.bound,
      setLiveSpinsByGame: action.bound,
      setAllGamesLiveSpins: action.bound,
      updateLiveSpinsByGame: action.bound,
      updateAllGamesLiveSpins: action.bound,
    });
  }

  setAllGamesLiveSpins(data) {
    let allGamesLiveSpins = [...data];
    if (allGamesLiveSpins.length > this.betCountView) {
      allGamesLiveSpins = allGamesLiveSpins.splice(0, this.betCountView);
    }
    this.allGamesLiveSpins = allGamesLiveSpins;
  }

  setSelectedColumn(id) {
    this.selectedColumn = id;
  }

  updateLiveSpinUpdate(spin) {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    this.updateAllGamesLiveSpins(spin);
    if (spin.gameId === +gameId) {
      this.updateLiveSpinsByGame(spin);
    }
  }

  updateAllGamesLiveSpins(spin) {
    let allGamesLiveSpins = [spin, ...this.allGamesLiveSpins];
    if (allGamesLiveSpins.length > this.betCountView) {
      allGamesLiveSpins = allGamesLiveSpins.splice(0, this.betCountView);
    }
    this.allGamesLiveSpins = allGamesLiveSpins;
  }

  setHighRollers(data = []) {
    let highRollers = [...data].sort((a, b) => b.amount - a.amount);
    if (highRollers.length > this.betCountView) {
      highRollers = highRollers.splice(0, this.betCountView);
    }
    this.highRollers = highRollers;
  }

  updateHighRollers(spin) {
    if (spin.gameId === +parseQuery(window.location.search).gameid) {
      let highRollers = [spin, ...this.highRollers].sort((a, b) => b.amount - a.amount);
      if (highRollers.length > this.betCountView) {
        highRollers = highRollers.splice(0, this.betCountView);
      }
      this.highRollers = highRollers;
    }
  }

  setLiveSpinsByGame(data = []) {
    let allGamesLiveSpinsByGame = [...data];
    if (allGamesLiveSpinsByGame.length > this.betCountView) {
      allGamesLiveSpinsByGame = allGamesLiveSpinsByGame.splice(0, this.betCountView);
    }
    this.liveSpinsByGame = allGamesLiveSpinsByGame;
  }

  updateLiveSpinsByGame(spin) {
    let allGamesLiveSpinsByGame = [spin, ...this.liveSpinsByGame];
    if (allGamesLiveSpinsByGame.length > this.betCountView) {
      allGamesLiveSpinsByGame = allGamesLiveSpinsByGame.splice(0, this.betCountView);
    }
    this.liveSpinsByGame = allGamesLiveSpinsByGame;
  }
}

export const liveUpdateStore = new LiveUpdateStore();
